// components/DownloadProgressModal.tsx
import React from "react";

interface DownloadProgressModalProps {
  progress: number;
  isOpen: boolean;
  onClose?: () => void;
}

export const DownloadProgressModal: React.FC<DownloadProgressModalProps> = ({
  progress,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-dark">
            Downloading Images
          </h3>
          <p className="text-sm text-gray-600">
            Please wait while your files are being downloaded
          </p>
        </div>

        <div className="mb-4">
          {progress === 0 ? (
            // Indeterminate blue loading bar
            <div className="w-full h-2.5 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-2.5 bg-blue-600 animate-pulse w-1/2 rounded-full" style={{ animation: 'indeterminate-bar 1.2s linear infinite' }}></div>
              <style>{`
                @keyframes indeterminate-bar {
                  0% { margin-left: -50%; width: 50%; }
                  50% { margin-left: 25%; width: 50%; }
                  100% { margin-left: 100%; width: 50%; }
                }
              `}</style>
            </div>
          ) : (
            <>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-center mt-2">{progress}%</p>
            </>
          )}
        </div>

        {progress === 100 && (
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};
